<script>
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";

export default {
    name: "CatalogFilterBlockLoading",
    components: {SpinnerIndicator}
}
</script>

<template>
    <div class="text-sm font-medium flex items-center pt-1 pb-1">
        Загружаем
        <SpinnerIndicator class="h-5 ms-2"/>
    </div>
</template>

<style scoped lang="scss">

</style>
